import { twMerge } from "tailwind-merge";


interface IPageContainerProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
}

function PageContainer({ children, className }: IPageContainerProps) {
  return <div className={twMerge('flex flex-col gap-6 w-full lg:max-w-screen-xl lg:mx-auto', className)}>{children}</div>
}

export default PageContainer;